import httpExpertClient from '@/plugins/httpExpertClient';

export default {
  getMark(id) {
    return httpExpertClient.get(`expert/compete/marks/${id}`);
  },
  patchMark(id, arr, comment) {
    return httpExpertClient.patch(`expert/compete/marks/${id}`, { compete_mark: { scores: arr, comment } });
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/expertApis/compete/markDetailApis.js